import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {Observable} from 'rxjs';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {GrandfatherDTO} from '../models/GrandfatherDTO';

@Injectable({
  providedIn: 'root'
})
export class GrandfatherService {
  private url = environment.baseUrl + '/grandfather';

  constructor(private httpClient: HttpClient) {
  }

  getListOfGrandfathers(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<GrandfatherDTO>> {
    return this.httpClient.post<PagedResponseDTO<GrandfatherDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  saveGrandfather(grandfatherDTO: GrandfatherDTO): Observable<GrandfatherDTO> {
    return this.httpClient.post<GrandfatherDTO>(this.url, grandfatherDTO);
  }

  deleteGrandfather(grandfatherId: number): Observable<{}> {
    return this.httpClient.delete<{}>(this.url + '/' + grandfatherId);
  }

  getGrandfather(grandfatherId: number): Observable<GrandfatherDTO> {
    return this.httpClient.get<GrandfatherDTO>(this.url + '/' + grandfatherId);
  }
}
